import React from 'react';
import { Linking, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import useAllStatus from '@src/hooks/useAllStatus';
import { AppPage } from '@src/enums';
import useHasPrime from '@src/hooks/useHasPrime';
import { EntityType } from '@src/types';

interface Props {
  link?: string;
  entityType?: EntityType;
  entityId?: string;
  parentEntityType?: EntityType;
  parentEntityId?: string;
}

const useHandleEntityPress = () => {
  const navigation = useNavigation();
  const hasPrime = useHasPrime();
  const allStatus = useAllStatus();
  return React.useCallback(
    ({ link, entityId, entityType, parentEntityId }: Props) => {
      console.log('ffh', entityId);
      return async () => {
        switch (entityType) {
          case 'PRIME':
            if (entityId) {
              navigation.navigate('PrimeBook', { id: entityId });
            }
            break;
          case 'TOUR':
            if (entityId) {
              navigation.navigate('Tour', { id: entityId });
            } else {
              navigation.navigate('Tours');
            }
            break;
          case 'COMMENT':
          case 'COMMENT_REPLY':
            if (parentEntityId) {
              navigation.navigate('Post', { id: parentEntityId });
            }
            break;
          case 'COLLECTION':
            if (entityId) {
              navigation.navigate('Collection', { id: entityId });
            }
            break;
          case 'CHECK_IN':
            if (entityId) {
              navigation.navigate('Post', { id: entityId });
            }
            break;
          case 'APP_PAGE':
            switch (entityId as AppPage) {
              case AppPage.TripAdvisor:
                if (
                  allStatus === undefined ||
                  allStatus[0]?.daysRemaining === undefined ||
                  allStatus[0]?.daysRemaining === 0
                ) {
                  navigation.navigate('PrimeTripAdvisor');
                } else {
                  navigation.navigate('PrimePlans');
                }
                break;
              case AppPage.PrimeHome:
                navigation.navigate('PrimeHome');

                break;
              case AppPage.ImmigrationHome:
                navigation.navigate('ImmigrationHome');

                break;
              case AppPage.Activity:
                navigation.navigate('Activities');
                break;
              case AppPage.Explore:
                navigation.navigate('Explore');
                break;
              case AppPage.Notification:
                navigation.navigate('Notifications');
                break;
              case AppPage.TourHome:
                navigation.navigate('TourHome');
                break;
              case AppPage.MainHome:
                navigation.navigate('Home');
                break;
              case AppPage.Profile:
                navigation.navigate('Profile');
                break;
              default:
                console.log(entityId);
            }
            break;
          case 'LINK': {
            if (entityId) {
              if (Platform.OS === 'web') {
                window.open(entityId, '_blank');
              } else {
                const supported = await Linking.canOpenURL(entityId);
                if (supported) {
                  await Linking.openURL(entityId);
                }
              }
            }
            break;
          }
          case 'USER': {
            if (entityId) {
              navigation.navigate('Profile', { id: entityId });
            }
            break;
          }
          case 'JOURNEY': {
            if (entityId) {
              navigation.navigate('Journey', { id: entityId });
            } else {
              navigation.navigate('Journey');
            }
            break;
          }
          case 'BUSINESS': {
            if (entityId) {
              navigation.navigate('Location', { id: entityId });
            }
            break;
          }
          default: {
            if (link) {
              if (Platform.OS === 'web') {
                window.open(link, '_blank');
              } else {
                const supported = await Linking.canOpenURL(link);
                if (supported) {
                  await Linking.openURL(link);
                }
              }
            } else {
              console.log(link, entityId, entityType, parentEntityId);
            }
          }
        }
      };
    },
    [hasPrime, navigation]
  );
};

export default useHandleEntityPress;
